import Icon from "../Icon/Icon.jsx";
import styles from "./inputSubmit.css";

/**
 * The submit input field is used in forms to send the steps with all its steps
 * data. It is different from a `Button` component in its specific HTML `input`
 * tag with `type=submit`. Both are styled in a similar way.
 *
 * A checkmark can be displayed alongside it, to indicate that the submission
 * was successfull. You need to control the state in the parent component and
 * turn completedSuccessfully to false if you want the checkmark to disappear.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.value - The label to display on the submit input.
 * @param {boolean} [props.disabled=false] - Determines if the submit input is disabled.
 * @param {boolean} [props.completedSuccessfully=false] - Indicates if the operation was successful, showing a checkmark icon if true.
 * @param {string} [props.width="fit-content"] - Determines the width of the submit input. Can be "fit-content" or "full".
 * @param {string} props.form - Submits a form when the InputSubmits lives outside of the form. We pass a string, which is passed to the form as "id"
 * @return {JSX.Element} A JSX element containing a submit input and a conditional success icon.
 */
function InputSubmit({
  value,
  disabled = false,
  completedSuccessfully = false,
  width = "fit-content",
  form,
}) {
  return (
    <>
      <input
        type="submit"
        className={styles.inputSubmit({ width })}
        value={value}
        disabled={disabled}
        form={form}
      />
      {completedSuccessfully && (
        <Icon name={"checkmark"} className={styles.icon} />
      )}
    </>
  );
}

export default InputSubmit;
